import { ref } from "vue";
import { downloadMediaFile } from "~/utils/downloadMediaFile";

export const useMediaDownload = () => {
  const isDownloading = ref(false);
  const downloadError = ref("");

  const downloadMedia = async (src: string) => {
    if (!src || isDownloading.value) return false;

    isDownloading.value = true;
    downloadError.value = "";

    try {
      await downloadMediaFile(src);
      return true;
    } catch (error) {
      downloadError.value =
        error instanceof Error && error.message
          ? error.message
          : "Файл недоступен для скачивания";
      return false;
    } finally {
      isDownloading.value = false;
    }
  };

  const resetDownloadState = () => {
    downloadError.value = "";
  };

  return {
    downloadError,
    downloadMedia,
    isDownloading,
    resetDownloadState,
  };
};
